<div class="container mt-4">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-8">
            <div class="card">
                <div class="card-body">
                    <div class="mb-2 text-center">
                        <i class="fa-solid fa-magnifying-glass mt-2 mb-4"></i>
                        <div class="heading-md mb-4">We can't find the claim resource you're looking for.</div>
                        <p class="caption-lg mb-5">
                            Please ensure you are using the correct link.
                            <br />
                            This resource is only accessible via the unique link sent to your email.
                        </p>
                        <p>
                            If you still cannot access using the link in your email, contact us at:
                            <a class="no-wrap" href="mailto:trp&#64;dewarinsurance.com">trp&#64;dewarinsurance.com</a><br />
                            or call&nbsp;<a class="no-wrap" href="tel:6177741555">617-774-1555.</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
